import { MsalProvider } from "@azure/msal-react";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { initializeIcons } from "@fluentui/react/lib/Icons";
import { initializeMsal, msalInstance } from "./Api/Common/Auth";
import App from "./App";
import "./index.css";
import { webLightTheme, FluentProvider } from "@fluentui/react-components";
import { DataAccessContextProvider } from "./Contexts/DataAccessContext";
import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { ToastProvider } from "./Contexts/ToastContext";
import { initializeAppInsights } from "./Shared/AppInsights";

// Initialize Fluent UI icons
initializeIcons();

// Initialize Application Insights
const reactPlugin = initializeAppInsights(
  process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING,
);

initializeMsal().then(() => {
  ReactDOM.render(
    <React.StrictMode>
      <AppInsightsContext.Provider value={reactPlugin}>
        <BrowserRouter>
          <MsalProvider instance={msalInstance}>
            <FluentProvider theme={webLightTheme} style={{ height: "100%" }}>
              <DataAccessContextProvider>
                <ToastProvider>
                  <App />
                </ToastProvider>
              </DataAccessContextProvider>
            </FluentProvider>
          </MsalProvider>
        </BrowserRouter>
      </AppInsightsContext.Provider>
    </React.StrictMode>,
    document.getElementById("root"),
  );
});

// --- FIX START: Fluent UI v9 ResizeObserver Patch ---
const OriginalResizeObserver = window.ResizeObserver as any;

window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
  constructor(callback: ResizeObserverCallback) {
    super((entries: ResizeObserverEntry[], observer: ResizeObserver) => {
      window.requestAnimationFrame(() => {
        if (!Array.isArray(entries) || !entries.length) return;

        // FIX: Cast 'observer' to 'any' to satisfy TypeScript (TS2345)
        callback(entries, observer as any);
      });
    });
  }
} as any;
// --- FIX END ---
